import React from 'react';

import { Block } from './Skeleton.styles';

export interface SkeletonProps {
  /** Height in px. */
  height: number;
  /** Border radius in px (default 8). */
  radius?: number;
  /** CSS width (default 100%). */
  width?: string;
}

/** A single flashing shimmer block — composed into the loading placeholders for
 *  the name cards / domain rows while the AI suggestions are fetched. */
export const Skeleton = ({ height, radius = 8, width = '100%' }: SkeletonProps): React.ReactElement => (
  <Block $h={height} $r={radius} $w={width} />
);

export default Skeleton;